import axios from "../libs/axios/axios-jobupload";
import { BaseBulkUploadService } from "./basebulkupload.service";

export const api = new BaseBulkUploadService(axios);
